import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, Inject, OnInit } from '@angular/core';
import { ProviderTypeService } from '../../service/provider-type.service';
import { HttpBaseService } from '../../service/http-base.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-custom-delete',
  templateUrl: './custom-mat-delete.component.html',
  styleUrls: ['./custom-mat-delete.component.sass']
})
export class CustomDeleteDialogComponent implements OnInit {
  public rows: string[];
  public deleteURL: string;
  public isRecurring: boolean = false;
  
  constructor(
    public dialogRef: MatDialogRef<CustomDeleteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public providerTypeService: ProviderTypeService,
    private httpService: HttpBaseService,
    private snackBar: MatSnackBar
  ) {
  }

  ngOnInit() {
    this.rows = this.data.patient;
    this.isRecurring = this.data.isRecurring;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
  confirmDelete(): void {
    this.httpService.delete(this.data.deleteURL, null).subscribe(res => {
      let data = res as boolean;
      if (data == true) {
        this.showNotification(
          'snackbar-success',
          'Delete Record Successfully...!!!',
          'bottom',
          'center'
        );
      }
      else {
        this.showNotification(
          'snackbar-danger',
          'Record cannot be deleted. It has association in the system.',
          'bottom',
          'center'
        );
      }
    });  
  }  

  confirmDeleteSeries(): void {
    this.httpService.delete(this.data.multiDeleteURL, null).subscribe(res => {
      let data = res as boolean;
      if (data == true) {
        this.showNotification(
          'snackbar-success',
          'Delete Records Successfully...!!!',
          'bottom',
          'center'
        );
      }
      else {
        this.showNotification(
          'snackbar-danger',
          'Record cannot be deleted. It has association in the system.',
          'bottom',
          'center'
        );
      }
    });
  }

  showNotification(colorName, text, placementFrom, placementAlign) {
    this.snackBar.open(text, '', {
      duration: 2000,
      verticalPosition: placementFrom,
      horizontalPosition: placementAlign,
      panelClass: colorName,
    });
  }
}
